import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Logo";

export function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#06090e]" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-5 py-16 sm:px-10">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
              US ISO merchant banking for high-risk processing and cross-border payments. The US desk of the FinBPM alliance.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="eyebrow mb-4">Platform</p>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li><Link to="/store" data-testid="footer-store-link" className="hover:text-white">Storefront</Link></li>
              <li><Link to="/apply" data-testid="footer-apply-link" className="hover:text-white">Apply for processing</Link></li>
              <li><Link to="/portal" data-testid="footer-portal-link" className="hover:text-white">Corridor Portal</Link></li>
              <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-white">Contact us</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="eyebrow mb-4">International partner</p>
            <a href="https://www.finbpm.tech" target="_blank" rel="noreferrer" data-testid="footer-finbpm-link"
              className="group inline-flex items-center gap-2 font-display text-2xl font-medium hover:text-[var(--gold)]">
              FinBPM <ArrowUpRight className="h-5 w-5 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
            <p className="mt-2 text-sm text-slate-400">Merchant of Record · International acquiring</p>
          </div>
        </div>
        <div className="mt-16 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 font-mono text-xs text-slate-400 sm:flex-row">
          <span>© {new Date().getFullYear()} MidHq.com</span>
          <span>[Registered ISO / sponsor bank disclosure placeholder]</span>
        </div>
      </div>
    </footer>
  );
}
